import Event from "../types/Event";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";

export default function useEventGet (
    id: string | number,
    options?: CacheQueryOpts
): CacheQueryOutput<Event> {
    const endpoint = typeof id === "number" ? `events/${id}` : id.substring(1); // Remove leading slash if present
    const client = useAPIClient();
    return useCacheQuery<Event>(
        ["event", id],
        () => {
            return client.get<any>(endpoint);
        },
        options
    );
}